import { Fragment, useContext, useEffect, useState } from "react";
import { RecievedAgainMessage, RecievedMessage } from "./Recieved_Message";
import { SendMessage, SendMessageAgain } from "./Send_Message";
import styles from "../../index.module.scss";
import { networkContext } from "../../../../contexts/NetworkContext/NetworkContextProvider";
import { getMessagebyRoomId } from "../../../../Managers/Chat";
import moment from "moment";

export const ChatSectionMessages = ({ recieverUserData, webinarId }) => {
  const { roomId } = useContext(networkContext);

  const [chatData, setChatData] = useState("");

  useEffect(() => {
    const chatSectionMessages = document.querySelector(
      `.${styles.chatMessagesSection}`
    );
    chatSectionMessages.scrollTop = chatSectionMessages.scrollHeight;
  }, [chatData]);

  useEffect(() => {
    setChatData("");
    if (webinarId && roomId) {
      getMessagebyRoomId(webinarId, roomId, (data) => {
        setChatData(Object.values(data));
      });
    } else {
      setChatData("");
    }
  }, [roomId, webinarId]);

  let currentDate = null;
  let lastSenderId = null;
  return (
    <div className={styles.chatMessagesSection}>
      <div className={styles.chat__messages__Container}>
        {chatData &&
          chatData?.map((data, index) => {
            let sameMessageAgain = false;
            if (lastSenderId === data.id) {
              sameMessageAgain = true;
            }
            lastSenderId = data.id;

            //------------------  Date Section -------------------------
            let currentMsgDate = moment(
              new Date(data.createdAt).toUTCString()
            ).format("DD MMMM, YYYY");

            let addDateHeader = false;
            if (currentMsgDate !== currentDate) {
              addDateHeader = true;
              currentDate = currentMsgDate;
            }

            if (addDateHeader) {
              sameMessageAgain = false;
            }

            if (recieverUserData) {
              if (data.id == recieverUserData?.id) {
                //------------------  Date Section -------------------------

                return (
                  <Fragment key={index + Math.random()}>
                    {addDateHeader && (
                      <div className={styles.chat__messages__date}>
                        <h4>{currentMsgDate}</h4>
                      </div>
                    )}
                    {sameMessageAgain ? (
                      <RecievedAgainMessage
                        key={index}
                        messageData={data}
                        userData={recieverUserData}
                      />
                    ) : (
                      <RecievedMessage
                        key={index}
                        messageData={data}
                        userData={recieverUserData}
                      />
                    )}
                  </Fragment>
                );
              } else {
                return (
                  <Fragment key={index + Math.random()}>
                    {addDateHeader && (
                      <div className={styles.chat__messages__date}>
                        <h4>{currentMsgDate}</h4>
                      </div>
                    )}
                    {sameMessageAgain ? (
                      <SendMessageAgain key={index} messageData={data} />
                    ) : (
                      <SendMessage key={index} messageData={data} />
                    )}
                  </Fragment>
                );
              }
            }
          })}
        {/* <RecievedMessage
            messageData={{ message: "hfdlalfdsa fdsa" }}
            userData={recieverUserData}
          />
          <SendMessage messageData={{ message: "dsafjk fdasfas" }} />
          <RecievedMessage
            messageData={{ message: "hfdlalfdsa fdsa" }}
            userData={recieverUserData}
          />
          <SendMessage messageData={{ message: "dsafjk fdasfas" }} />
          <RecievedMessage
            messageData={{ message: "hfdlalfdsa fdsa" }}
            userData={recieverUserData}
          />
          <SendMessage messageData={{ message: "dsafjk fdasfas" }} />
          <RecievedMessage
            messageData={{ message: "hfdlalfdsa fdsa" }}
            userData={recieverUserData}
          />
          <SendMessage messageData={{ message: "dsafjk fdasfas" }} />
          <RecievedMessage
            messageData={{ message: "hfdlalfdsa fdsa" }}
            userData={recieverUserData}
          />
          <SendMessage messageData={{ message: "dsafjk fdasfas" }} />
          <RecievedMessage
            messageData={{ message: "hfdlalfdsa fdsa" }}
            userData={recieverUserData}
          />
          <SendMessage messageData={{ message: "dsafjk fdasfas" }} /> */}
      </div>
    </div>
  );
};
